import type { ErrorInfo } from 'react'

import { ResidentAppError } from '../../common/error'
import { recordCloudWatchRumError } from '../cloudwatch-rum'

/**
 * Reports errors caught by error boundaries to CloudWatch RUM. ResidentAppErrors
 * are expected API and domain errors that the backend already logs, so they are
 * skipped. RUM only runs when the user has consented to tracking.
 */
export const reportCaughtError = (error: unknown, errorInfo: ErrorInfo) => {
  // eslint-disable-next-line no-console
  console.error(error, errorInfo.componentStack)

  if (!(error instanceof ResidentAppError)) {
    recordCloudWatchRumError(error)
  }
}
